(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["giftexpress-product-about"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const control = event.target;
    if (!(control instanceof HTMLInputElement) && !(control instanceof HTMLSelectElement)) return;
    if (!control.closest('.product-details variant-picker')) return;

    const details = control.closest('.product-details');
    const output = details?.querySelector('[data-gex-product-size]');
    const selected = details?.querySelector('variant-picker input:checked, variant-picker select');

    if (output && selected && selected.value) output.textContent = selected.value;
  });
  } catch(e) { console.error(e); }
})();

})();
